import { useQueryClient } from "@tanstack/react-query";
import { useAuthQuery, useAuthMutation } from "@rentablo/api";
import { CACHE_KEYS } from "@rentablo/api/apiv1";
import {
  getDepotSynchronizationLog,
  getDepotSynchronizationLogs,
  rollbackDepotSynchronizationLog,
} from "@api/v1/methods";
import { GetDepotSynchronizationLogParams } from "@api/v1/model";

export const useGetDepotSynchronizationLog = (id?: number) =>
  useAuthQuery(
    ["get-synchronization-log", id!],
    ({ token }) => getDepotSynchronizationLog(token, id!),
    {
      enabled: !!id,
    }
  );

export const useGetDepotSynchronizationLogs = (
  params?: GetDepotSynchronizationLogParams
) =>
  useAuthQuery(
    ["get-synchronization-logs", params!],
    ({ token }) => getDepotSynchronizationLogs(token, params!),
    {
      enabled: !!params,
    }
  );

export const useRollbackDepotSynchronizationLog = () => {
  const queryClient = useQueryClient();
  return useAuthMutation(rollbackDepotSynchronizationLog, {
    throwOnError: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-synchronization-logs"],
      });
      queryClient.invalidateQueries({
        queryKey: [CACHE_KEYS.LIST_AND_SEARCH_ALL_BOOKINGS],
      });
    },
  });
};
